<template>
    <div>

        <div class="header-select-battery">Select Slot</div>
        <div v-if="batteryStation.length > 1">
            <div class="container">
                <span class="select-battery" v-for="(battery, i) in batteryStation" :key="i"
                    @click=" openBatteryModal(battery)">
                    <Battery :battery="battery"></Battery>
                </span>
            </div>
        </div>
        <div v-else>

            <v-row no-gutters>
                <div class="station-loader" v-for="index in 5" :key="index">
                    <v-col>
                        <v-skeleton-loader class="left-col-loader" max-width="300" type="image" width="160"
                            height="75"></v-skeleton-loader>
                    </v-col>
                    <v-col>
                        <v-skeleton-loader class="right-col-loader" max-width="300" type="image" width="160"
                            height="75"></v-skeleton-loader>
                    </v-col>
                </div>
            </v-row>
        </div>

        <!-- email secretkey -->
        <!-- <div v-if="isModalOpen" class="modal"> -->
        <div v-if="isModalOpen" class="modal">
            <v-dialog v-model="dialogVisible" persistent max-width="325">
                <div class="modal-content">
                    <img src="../assets/Swap.png" />
                    <div style="margin: 24px 0;">
                        <div class="modal-title">Are you sure you want to swap this locker ?</div>
                        <div class="modal-detail">The locker will open after you confirm this locker.</div>
                    </div>
                    <div class="group-btn">
                        <button @click="closeBatteryModal" class="cancel-btn">Cancel</button>
                        <button @click="confirmRoute" class="confirm-btn">Confirm</button>
                    </div>
                </div>
            </v-dialog>
        </div>
        <div v-else-if="isModalBatteryCharging" class="modal">
            <v-dialog v-model="dialogVisible" persistent max-width="325">
                <div class="modal-content">
                    <img src="../assets/SwapCharging.png" />
                    <div style="margin: 24px 0;">
                        <div class="modal-title">Batteries is charging</div>
                        <div class="modal-detail">Batteries in this locker is charging. Please wait until 80% or select
                            other
                            locker.</div>
                    </div>
                    <div class="group-btn">
                        <button @click="closeBatteryModal" class="confirm-btn">Close</button>
                    </div>
                </div>
            </v-dialog>
        </div>
        <div v-else-if="isModalBatteryNotAvailable" class="modal">
            <v-dialog v-model="dialogVisible" persistent max-width="325">
                <div class="modal-content">
                    <img src="../assets/notAvailable.png" />
                    <div style="margin: 24px 0;">
                        <div class="modal-title">This locker is not available !</div>
                        <div class="modal-detail">This locker can’t be use now. Please wait and try again later.</div>
                    </div>
                    <div class="group-btn">
                        <button @click="closeBatteryModal" class="confirm-btn">Close</button>
                    </div>
                </div>
            </v-dialog>
        </div>
    </div>
</template>
  
<script>
import Button from "../components/Button.vue"
import Battery from "../components/Battery.vue"

export default {
    name: 'Station',
    components: {
        Button,
        Battery
    },
    data() {
        return {
            stationId: '',
            batteryStation: [],
            selectedBattery: null,
            isModalOpen: false,
            selectedBatteryForModal: null,
            isModalBatteryCharging: null,
            isModalBatteryNotAvailable: null,
            dialogVisible: true,
        }
    },
    methods: {
        async fetchData() {
            try {
                let response = await this.$apiFire('Station/onGetBatteryStation', parseInt(this.stationId)) // Station id
                // console.log('battery api ', response);
                this.batteryStation = response;
            } catch (error) {
                console.log(error);
            }
        },
        async openLocker() {
            try {
                // let response = await this.$apiFire('Station/onOpenLocker', parseInt(this.selectedBatteryForModal.id)) // locker id
                // let response = await this.$apiFire('Station/onOpenLocker/', { 'slot': this.selectedBatteryForModal.id });
                let response = await this.$apiFire('Station/onOpenLocker', this.selectedBatteryForModal.id);

                console.log(response);
            } catch (error) {
                console.log(error);
            }
        },
        routeTo(route, battery) {
            if (!route) return
            console.log(route)
            this.$router.push({ name: route, params: { selectedBattery: battery } })
        },
        selectBattery(number) {
            console.log(number)
            this.selectedBattery = number;
        },
        openBatteryModal(battery) {
            if (battery.status === '1') {
                this.selectedBatteryForModal = battery;
                if (battery.battery_percent >= 80) {
                    this.isModalOpen = true;
                } else if (battery.battery_percent < 80) {
                    this.isModalBatteryCharging = true;
                }
            } else {
                this.isModalBatteryNotAvailable = true;
            }

        },
        closeBatteryModal() {
            this.isModalOpen = false;
            this.isModalBatteryCharging = false;
            this.isModalBatteryNotAvailable = false;
        },

        confirmRoute() {
            if (this.selectedBatteryForModal) {
                // this.routeTo('StepChangeBattery', this.selectedBatteryForModal);
                this.$router.push({ name: 'StepChangeBattery', query: { slot: this.selectedBatteryForModal } })
                this.openLocker();
                //
                this.closeBatteryModal();
            }
        },
    },
    created() {
        this.stationId = this.$route.query.station;
        // console.log(this.stationId)
        // console.log(typeof (parseInt(this.stationId)))

        this.fetchData();
    },
    mounted() {
        // setInterval(() => {
        //     this.fetchData();
        // }, 5000);
    },

}
</script>
  
  
<style scoped>
* {
    --width-size: 150px;
    --height-size: 60px;
}

.header-select-battery {
    width: 100%;
    padding: 30px 0 20px 30px;
    font-size: 16px;
    font-weight: 600;
    font-style: normal;
}

.container {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    display: flex;
}

.select-battery {
    margin-bottom: 8px;
}

.select-battery:nth-child(odd) {
    margin-right: 16px;
}

.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px;
    z-index: 99;
}

.modal-content {
    background-color: #fff;
    width: 325px;
    padding: 20px 24px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.modal-content img {
    width: 93px;
}

.modal-title {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 12px;
}

.modal-detail {
    font-size: 14px;
    color: #C1C1C1;
}

.group-btn {
    display: flex;
    width: 100%;
}

.cancel-btn {
    font-size: 16px;
    padding: 8px 16px;
    color: #FE9900;
    border: 1px solid #FE9900;
    border-radius: 8px;
    width: 100%;
    margin-right: 5px;
}

.confirm-btn {
    font-size: 16px;
    padding: 8px 16px;
    color: #fff;
    background: linear-gradient(50deg, #FE9900 38.93%, #FFCD82 97.25%);
    border-radius: 8px;
    width: 100%;
}

.station-loader {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: auto;
    margin-bottom: -15px;
    /* background: palegreen; */
    /* margin-right: -50px; */
}

.left-col-loader {
    /* margin-left: 65px; */
    margin: auto;
    left: 5px;
}

.right-col-loader {
    /* margin-right: 65px; */
    margin: auto;
    right: 5px;
}

.show-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: palegreen;
}

/* .dialog-modal {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    background: palegreen;
} */
</style>